import React, { useState } from "react";
import PageHeader from "./PageHeader";
import "../styles/LedgerPage.css";
import { fetchLedgerPdf } from "../services/api";

function getDefaultFromDate() {
  const now = new Date();
  const fyStartYear = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  return `${fyStartYear}-04-01`;
}

function getTodayDate() {
  return new Date().toISOString().slice(0, 10);
}

function LedgerPage({ dealer }) {
  const [fromDate, setFromDate] = useState(getDefaultFromDate());
  const [toDate, setToDate] = useState(getTodayDate());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDownload = async () => {
    if (!dealer?.sessionToken) {
      setError("Unable to identify your account. Please log in again.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const blob = await fetchLedgerPdf(fromDate, toDate);
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `Ledger-${fromDate}_to_${toDate}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      setError(err.message || "Unable to generate ledger right now. Please try again in a moment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ledger-page">
      <PageHeader title="Download Ledger" />

      <main className="ledger-content">
        <div className="ledger-card">
          <p className="ledger-account-label">
            Account: <span>{dealer?.accountName || dealer?.username}</span>
          </p>

          <div className="ledger-form">
            <div className="ledger-field">
              <label htmlFor="fromDate">From Date</label>
              <input
                id="fromDate"
                type="date"
                className="ledger-input"
                value={fromDate}
                max={toDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="ledger-field">
              <label htmlFor="toDate">To Date</label>
              <input
                id="toDate"
                type="date"
                className="ledger-input"
                value={toDate}
                min={fromDate}
                max={getTodayDate()}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>

          {error && <p className="ledger-error-banner">{error}</p>}

          <button
            className="ledger-download-button"
            onClick={handleDownload}
            disabled={loading}
          >
            {loading ? "Generating ledger..." : "Download Ledger"}
          </button>
        </div>
      </main>
    </div>
  );
}

export default LedgerPage;
